module.exports = __webpack_public_path__ + "static/media/jsimg.c2e4a7cf.jpg";